import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AbstractControl, NgModel, ValidationErrors } from '@angular/forms';

@Component({
    selector: 're-user-conversion-to-federation-confirmation-dialog',
    templateUrl: './user-conversion-to-federation-confirmation-dialog.component.html',
    styleUrls: ['./user-conversion-to-federation-confirmation-dialog.component.scss'],
    standalone: false
})
export class UserConversionToFederationConfirmationDialogComponent implements OnInit {
  federationLoginIdEnabled: boolean;
  federatedLoginID: string=null;
  userName: string;
  selectedFederatedLoginIdDomain = "";

  @ViewChild("federatedLoginIdControl")
  federatedLoginIdControl: NgModel;

  private _sameAsUsername = false;
  public get sameAsUsername() {
    return this._sameAsUsername;
  }
  public set sameAsUsername(value) {
    this._sameAsUsername = value;

    if (this.sameAsUsername) {
      this.federatedLoginID = this.userName;
    }
    else {
      let index = this.federatedLoginID.indexOf("@");
      if (index >= 0)
        this.federatedLoginID = this.federatedLoginID.substr(0, index - 1);
    }

  }

  private _usernameDomains: string[];
  public get usernameDomains(): string[] {
    return this._usernameDomains;
  }
  public set usernameDomains(value: string[]) {
    this._usernameDomains = value;

    if (this.usernameDomains && this.usernameDomains.length > 0) {
      this.selectedFederatedLoginIdDomain = this.usernameDomains[0];
    }
  }

  constructor(private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.federatedLoginIdControl.control.addValidators((control) => this.containsDomainInformationValidator(control));

    })
  }

  containsDomainInformationValidator(control: AbstractControl): ValidationErrors | null {

    if (!control.value)
      return null;
    if (control.value.trim() == "")
      return null;

    let index = control.value.toString().indexOf("@");
    if (index >= 0) {

      return { containsDomain: control.value.substr(index) };
    }
    return null;
  }



  accept() {
    if (this.federationLoginIdEnabled) {
      if (!this.sameAsUsername) {
        this.federatedLoginID = this.federatedLoginID += "@" + this.selectedFederatedLoginIdDomain;
      }
    }
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
